import "prismjs/themes/prism-tomorrow.css";
import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import Prism from 'prismjs';
import "prismjs/components/prism-json";
import {
	Box,
	HStack,
	Text,
	Button,
} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../../components/form'
import { fetchWrapper } from '../../../../helpers';
import { LuArrowLeftCircle, LuTrash2 } from "react-icons/lu";

function Create({ getPage, channel_id }) {

	const [customerList, setCustomerList] = useState([])
	const [payload, setPayload] = useState('');
	const [header, setHeader] = useState('');

	const [initialValues, setInitialValues] = useState(null);

	const [formData, setFormData] = useState({
		account_name: '',
		customer_id: '',
		method: '',
		url: '',
		headers: [
			{
				key: '',
				value: '',
			}
		],
		payloads: [
			{
				key: '',
				value: '',
			}
		],
		status_id: '0'



	});

	const FormSchema = Yup.object().shape({
		account_name: Yup.string()
			.required('Account name is required')
			.min(3, 'Account name must be at least 3 characters')
			.max(50, 'Account name must be less than 50 characters'),

		customer_id: Yup.string()
			.required('Customer selection is required'),

		url: Yup.string()
			.required('API endpoint URL is required')
			.url('Please enter a valid URL. Include https:// or http://')
			.max(2000, 'URL is too long'),

		method: Yup.string()
			.required('API method is required')
			.oneOf(['Post', 'Get'], 'Method must be either Post or Get'),

		status_id: Yup.string()
			.required('Status selection is required'),

		headers: Yup.array().of(
			Yup.object().shape({
				// Headers are optional — an empty row is skipped rather than rejected.
				// The no-spaces check has to pass on a blank key for that to hold.
				key: Yup.string()
					.test('no-spaces', 'Header key cannot contain spaces',
						value => !value || !value.includes(' ')),
				value: Yup.string()
			})
		),

		payloads: Yup.array().when('method', {
			is: 'Post',
			then: schema => schema.of(
				Yup.object().shape({
					key: Yup.string()
						.required('Payload key is required')
						.test('no-spaces', 'Payload key cannot contain spaces',
							value => value && !value.includes(' ')),
					value: Yup.string()
						.required('Payload value is required')
				})
			),
			otherwise: schema => schema
		})
	});

	useEffect(() => {
		loadCustomerList()
	}, [])
	useEffect(() => {
		if (!initialValues || formData.headers.length > 0) {
			setInitialValues({ ...formData });
		}
		Prism.highlightAll();
	}, []);

	useEffect(() => {
		Prism.highlightAll();
	}, [payload]);


	const loadCustomerList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer/list`;
		const response = await fetchWrapper.get(url)
		const customerList = response.data;

		const allCustomersEntry = { id: 0, name: "All Customers" };


		const updatedData = [allCustomersEntry, ...customerList];
		let data = updatedData?.map(item => ({ id: item.id, name: item.business_name || item.name }))
		const db = { data: data };
		setCustomerList(db);
	}








	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = {
			...values,
		}
		data.header = header;
		data.payload = payload;


		const api_config = {
			header: header,
			payload: payload,
			url: data.url,
			method: data.method
		}

		const postData = {
			customer_id: data.customer_id,
			status_id: data.status_id,
			channel_id: channel_id,
			api_config: api_config,
			account_name: data.account_name,
		}


		const url = `${process.env.REACT_APP_API_URL}/channel_api_config/create`;
		await fetchWrapper.post(url, postData)
		getPage('list', channel_id)

	}

	const methodList = {
		data: [
			{ id: 'Post', name: 'Post' },
			{ id: 'Get', name: 'Get' }
		]
	};



	const addHeader = () => {
		const newheaders = {
			key: '',
			value: '',
		};


		const updatedFormData = {
			...formData,
			headers: [...formData.headers, newheaders]
		};
		setFormData(updatedFormData);
	};


	const addPayload = () => {
		const newPayload = {
			key: '',
			value: '',
		};


		const updatedFormData = {
			...formData,
			payloads: [...formData.payloads, newPayload]
		};
		setFormData(updatedFormData);
	}

	const removeHeader = (index) => {
		const updatedHeadersData = [...formData.headers];
		updatedHeadersData.splice(index, 1);

		const updatedFormData = {
			...formData,
			headers: updatedHeadersData
		};

		setFormData(updatedFormData);
	};

	const removePayload = (index) => {
		const messageObject = {};
		const updatedPayloadData = [...formData.payloads];
		updatedPayloadData.splice(index, 1);

		const updatedFormData = {
			...formData,
			payloads: updatedPayloadData
		};

		updatedPayloadData.forEach(payloads => {
			messageObject[payloads.key] = payloads.value;
		});
		setPayload(messageObject)

		setFormData(updatedFormData);
	};



	const handleHeaderChange = (index, field, value) => {
		const messageObject = {};
		const updatedHeaders = formData.headers.map((header, i) => {
			if (i === index) {
				return { ...header, [field]: value };
			}
			return header;
		});

		updatedHeaders.forEach(header => {
			messageObject[header.key] = header.value;
		});

		setHeader(messageObject)

		setFormData(prevState => ({
			...prevState,
			headers: updatedHeaders
		}));
	};


	const handlePayloadChange = (index, field, value) => {

		const messageObject = {};
		const updatedPayloadData = formData.payloads.map((payload, i) => {
			if (i === index) {
				return { ...payload, [field]: value };
			}
			return payload;
		});


		updatedPayloadData.forEach(payload => {
			messageObject[payload.key] = payload.value;
		});

		Prism.highlightAll();
		setPayload(messageObject);



		setFormData(prevState => ({
			...prevState,
			payloads: updatedPayloadData
		}));
	};

	const statusList = {
		data: [
			{ id: '1', name: 'Active' },
			{ id: '0', name: 'InActive' }
		]
	};

	return (

		<div className="setting_detail_section">
			<HStack>
				<Box>
					<LuArrowLeftCircle style={{ fontSize: '24px', cursor: 'pointer' }} onClick={() => getPage('list', channel_id)} />
				</Box>
				<Box>
					<h2 className="main_heading">SMS API Account</h2>
				</Box>
			</HStack>
			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={initialValues}
				onSubmit={onSubmit}
			>


				<InputText name="account_name" title="Account Name" inputProps={{ isRequired: true }} placeholder="Enter Account Name" />
				<SelectField name="customer_id" title="Customers" list={customerList} isRequired/>

				<HStack alignItems="end" w="100%">
					<Box w="15%">
						<SelectField name="method" title="API Endpoint" list={methodList} isRequired/>
					</Box>
					<Box w="85%">
						<InputText name="url" title="" placeholder="API Endpoint" inputProps={{ isRequired: true }} />
					</Box>
				</HStack>

				<Box mb="10px">
					<Text fontSize="14px" mb="0px">Api Header</Text>
					{formData.headers.map((head, index) => (
						<HStack key={index} w="100%" mt="10px" alignItems="baseline">
							<Box w="30%">
								<InputText name={`headers[${index}].key`} title="" placeholder="key" onChange={(e) => handleHeaderChange(index, 'key', e)} />
							</Box>
							<Box w="60%">
								<InputText name={`headers[${index}].value`} title="" placeholder="value" onChange={(e) => handleHeaderChange(index, 'value', e)} />
							</Box>




							{index !== 0 ?
								<Box w="10%" onClick={() => removeHeader(index)}>
									<LuTrash2 style={{ cursor: 'pointer' }} />
								</Box>
								: ""}
						</HStack>
					))}
					<Button onClick={addHeader}
						bg="#FFFFFF"
						fontSize="12px"
						borderColor="#CCCCCC"
						borderWidth="1px"
						px="30px"
					>Add</Button>
				</Box>



				<Box mb="20px">
					<Text fontSize="14px" mb="0px">API Payload Variables</Text>
					{formData.payloads.map((head, index) => (
						<HStack key={index} w="100%" mt="10px" alignItems="baseline">
							<Box w="30%">
								<InputText name={`payloads[${index}].key`} title="" placeholder="key" onChange={(e) => handlePayloadChange(index, 'key', e)} inputProps={{ isRequired: true }} />
							</Box>
							<Box w="60%">
								<InputText name={`payloads[${index}].value`} title="" placeholder="value" onChange={(e) => handlePayloadChange(index, 'value', e)} inputProps={{ isRequired: true }} />
							</Box>




							{index !== 0 ?
								<Box w="10%" onClick={() => removePayload(index)}>
									<LuTrash2 style={{ cursor: 'pointer' }} />
								</Box>
								: ""}
						</HStack>
					))}
					<Button onClick={addPayload}
						bg="#FFFFFF"
						fontSize="12px"
						borderColor="#CCCCCC"
						borderWidth="1px"
						px="30px"

					>Add</Button>
				</Box>


				<pre style={{ backgroundColor: 'black', textShadow: 'none', color: 'white', padding: '0px', borderRadius: '8px' }}>
					<span style={{ padding: 15, backgroundColor: '#2F2F2F', fontSize: '14px', display: 'block', marginBottom: '10px' }}>json</span>
					<code className="language-json" style={{ padding: '0px 15px 15px', display: 'block' }}>
						{JSON.stringify(payload, null, 2)}
					</code>
				</pre>

				<Box w="30%">
					<SelectField name="status_id" title="Status" list={statusList} isRequired/>
				</Box>


				<HStack alignItems="baseline" w="100%" mt="10px">
					<Box>
						<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
							mb={4}


							type='submit'
						>
							Add API Account
						</Button>
					</Box>
					<Box>
						<Button py="10px" px="25px" color="#000000" bg="#FFFFFF" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
							mb={4}
							borderColor="#CCCCCC"
							borderWidth="1px"
							onClick={() => getPage('list', channel_id)}
						>
							Cancel
						</Button>
					</Box>

				</HStack>

			</Form>
		</div>


	)
}

export default Create;